/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString, getDeepObj } from '@utils/format';

export const state = () => ({
  lokasi: {},
});

export const mutations = {
  SET_LOKASI(state, newValue) {
    state.lokasi = newValue;
  },
};

export const actions = {
  async fetch({ commit }, payload) {
    const url = `/lokasi?${queryString(payload.params)}`;
    const resp = await http.get(url).then(({ data }) => data);

    let data = {};
    resp['data'].forEach((key) => {
      data[getDeepObj(key, 'attributes.lokasi_id')] = getDeepObj(key, 'attributes.nama');
    });

    commit('SET_LOKASI', data);

    return resp;
  },

  create({}, payload) {
    const url = `/lokasi`;
    return http.post(url, payload.params);
  },

  detail({}, payload) {
    const url = `/lokasi/${payload}`;
    return http.get(url).then(({ data }) => data);
  },

  update({}, payload) {
    const url = `/lokasi/${payload.id}`;
    return http.patch(url, payload.params);
  },

  status({}, payload) {
    const url = `/lokasi/${payload.id}/${payload.status}`;
    return http.post(url);
  },

  delete({}, payload) {
    const url = `/lokasi/${payload.id}`;
    return http.delete(url);
  },
};
